export const DATE_RANGE_CONFIG = [
  { value: '0', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last_week', label: 'Last Week' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_3_months', label: 'Last 3 Months' },
];

export const DATE_RANGE_TAT_CONFIG = [
  { value: 'tatToday', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last_week', label: 'Last Week' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_3_months', label: 'Last 3 Months' },
];

export const DATE_SWITCHER_CONFIG = [
  { label: 'Daily', value: '0' },
  { label: 'Weekly', value: '7' },
  { label: 'Monthly', value: '30' },
];

export const DEFAULT_REPORTING_FILTERS = {
  dateFilter: '0',
  payer: [],
  claimStatus: [],
};

export const REPORTING_CONSTANTS = {
  REPORTING_WRITE_ACCESS: 'Reporting_Module_W',
  REPORTING_DISPLAY_FORMAT: 'dd/MM/yy',
  REPORTING_PLACEHOLDER: 'dd/mm/yy',
  ON_REQUEST_REPORT: 'On Request Report',
  DRAG_AND_REARRANGE_COLUMNS: 'Drag and rearrange columns for download',
  REMOVED_COLUMNS: 'Removed Columns',
  SELECT_AT_LEAST_ONE_COLUMN: 'select at least one column to download',
  CHOOSE_FILE_FORMAT: 'Choose File Format',
  DOWNLOAD_AS_XLSX: 'Download as .xlsx',
  DOWNLOAD_AS_CSV: 'Download as .csv',
  DATA_AVAILABLE_FROM: 'Data Available From',
  LAST_REFRESHED_ON: 'Last Refreshed On',
  REFRESHED: 'Refreshed',
  FILTER_BY: 'Filter By',
  XLSX: 'xlsx',
  CSV: 'csv',
  EXCEL: 'excel',
  ON_REQUEST_REPORT_KEY: 'onRequestReport',
  DOWNLOAD_SUCCESSFUL: 'Download Successful',
  DOWNLOAD_URL: 'Provider/Report/DownloadTransactionCountReport',
  ENTER_EMAIL: 'Enter email address',
  ENTER_EMAIL_TEXT: '(Type in the email address and press Enter. You can add multiple email address)',
  DAILY: 'Daily',
  DAILY_TIME_RANGE_PROMPT: 'What time range should the daily report cover?',
  DAILY_TIME_RANGE_FOOTER:
    'You’ll receive the report 1 hour after the end time.',
  SCHEDULE_PROMPT: 'Choose your preferred schedule:',
  SCHEDULE_FOOTER: `We'll send you a downloadable raw data in .xlsx format at your selected frequency.`,
  DOWNLOAD_REPORT_PROMPT: `Click download or click customise to rearrange/ remove unwanted columns`,
  SHARE_REPORT_PROMPT: 'Share this report directly to an email of your choice.',
  SHARE_REPORT_TEXT:
    'Enter the recipient’s email address and we’ll send them a copy instantly.',
  GET_REPORTS_DELIVERED:
    'Get reports delivered straight to your inbox — no need to log in every time.',
  REQUEST_FOR_OLD_REPORT:
    'Request for report more than 3 months. You will receive your request on the preferred email in 15 Minutes.',
  REQUEST_ENTER_EMAIL: 'Enter the recipient’s email address',
  REQUEST_SELECT_TIME_RANGE: 'Select a duration or date range for your report',
  REQUEST_DOWNLOAD_FOOTER: `We'll send you a downloadable raw data in .xlsx format of the selected time period.`,
  DOWNLOAD_TRANSACTION_REPORT: 'Download Transaction Report',
  SHARE_REPORT: 'Share Report',
  SCHEDULE_REPORT: 'Schedule Report',
  SCHEDULE_REPORT_KEY: 'scheduleReport',
  DOWNLOAD_REPORT_KEY: 'downloadReport',
  SEND_AS_MAIL_KEY: 'sendAsMail',
  DOWNLOAD_REPORT: 'Download Report',
  SEND_REPORT_AS_MAIL: 'Send Report As A Mail',
  SEARCH_CRITERIA_MESSAGE: 'Please Refine Your Search Criteria',
  EVERY_15_MINUTES: 'Every 15 Minutes',
  ALL: 'all',
  PLEASE_REFINE_YOUR_SEARCH_CRITERIA: 'Please Refine Your Search Criteria',
  TRANSACTION_TAT_REPORT: 'Transaction TAT Report',
  COMING_SOON: 'This feature is coming soon.',
  ADOPTION_REPORT: 'Adoption Report',
  NAVIGATION_FIRING_THRESHOLD: [0.25, 0.5, 0.75],
  NAVIGATION_ROOT_MARGIN: '-10% 0px -70% 0px',
  TAT_DAILY: 'tatToday',
  TRANSACTION_TAT: 'TRANSACTION_TAT',
  ONREQUEST_REPORT: 'OnRequest Report',
  ZERO_STRING: '0',
  TAT_TYPE: 'TAT Type',
  CLAIM_STATUS: 'Claim Status',
  STATUS_STRING: 'Status',
};

export const REPORTING_BUTTON_TEXT = {
  DOWNLOAD: 'Download',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  RESET: 'Reset',
  CUSTOMISE: 'Customise',
  CONFIRM: 'Confirm',
};

export const REPORT_ROUTE_MAP: Record<string, string> = {
  '/reporting-and-analytics/transaction-count-report': 'TRANSACTION_COUNT',
  '/reporting-and-analytics/transaction-tat-report': 'TRANSACTION_TAT',
  // '/reporting-and-analytics/adoption-report': 'ADOPTION',
};

export const REPORT_ROUTE_MAP_CONFIG: Record<string, string> = {
  'TRANSACTION_COUNT': 'reportingTransactionConfigList',
  'TRANSACTION_TAT': 'reportingTATConfigList',
  // 'ADOPTION_REPORT': 'reportingAdoptionConfigList',
};

export const REPORTING_COLUMN_CONFIG_MAP: Record<string, string> = {
    TRANSACTION_COUNT: 'ReportingSearchParamList',
    TRANSACTION_TAT: 'ReportingTATConfigList',
  };

export const REPORTING_TYPE_CONSTANTS = {
  TRANSACTION_COUNT: 'Transasction-Report',
  TRANSACTION_TAT: 'Tat-Report',
  // ADOPTION: 'Adoption',
};
